export function LocationModel({
    userType,
    name,
    id,
    uid,
    invitationUid,
    allowsSubinvitations,
    timezone
} = {}) {
    return {
        userType,
        name,
        id,
        uid,
        invitationUid,
        allowsSubinvitations,
        timezone
    };
}